import React, { useMemo } from 'react';
import './OHLCInfoOverlay.css';

interface Candle {
  time: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
}

interface OHLCInfoOverlayProps {
  candle: Candle | null;
}

const OHLCInfoOverlay: React.FC<OHLCInfoOverlayProps> = React.memo(({ candle }) => {
  if (!candle) {
    return null;
  }

  // Format time in PST (concise: MM/DD HH:MM) - memoized
  const formattedTime = useMemo(() => {
    const date = new Date(candle.time * 1000);
    const month = date.toLocaleString('en-US', { month: '2-digit', timeZone: 'America/Los_Angeles' });
    const day = date.toLocaleString('en-US', { day: '2-digit', timeZone: 'America/Los_Angeles' });
    const time = date.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'America/Los_Angeles' });
    return `${month}/${day} ${time}`;
  }, [candle.time]);

  return (
    <div className="ohlc-info-overlay">
      <div className="ohlc-info-content">
        <div className="ohlc-info-item">
          <span className="ohlc-info-label">TIME:</span>
          <span className="ohlc-info-value">{formattedTime}</span>
        </div>
        <div className="ohlc-info-item">
          <span className="ohlc-info-label">O:</span>
          <span className="ohlc-info-value">{candle.open.toFixed(2)}</span>
        </div>
        <div className="ohlc-info-item">
          <span className="ohlc-info-label">H:</span>
          <span className="ohlc-info-value">{candle.high.toFixed(2)}</span>
        </div>
        <div className="ohlc-info-item">
          <span className="ohlc-info-label">L:</span>
          <span className="ohlc-info-value">{candle.low.toFixed(2)}</span>
        </div>
        <div className="ohlc-info-item">
          <span className="ohlc-info-label">C:</span>
          <span className="ohlc-info-value">{candle.close.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
});

export default OHLCInfoOverlay;
